<!-- Fligth new design -->
@if (
  {
    flightResultsArray: (flightResults$ | async) || [],
    dualFlightResultsArray: (dualFlightResults$ | async) || [],
    loading: (searchParams.isLoading | async)
  };
  as data
) {
  <div>
    <h2 class="visuallyhidden" i18n="@@flight_searchCriteria">Search Criteria</h2>
    <a
      href="#flight-container-1"
      (click)="skipToResultContent()"
      role="link"
      class="sr-only sr-only-focusable"
      >Skip to result content</a
    >
    <app-invoked-user></app-invoked-user>
  </div>
  <div class="flight_container">
    @if (show_errors) {
      <div class="form_validation">
        <button class="error_validation_close" (click)="closeValidationErrors()" aria-label="Close">
          <i class="ico-cancel" aria-hidden="true"></i>
        </button>
        @for (error of errorsList; track error) {
          <span class="validation_error">{{ error | translate }}</span>
        }
      </div>
    }
    <div class="flight_research_form background-container-background">
      <app-search-toggle [serviceType]="ServiceType.Flight">
        <app-flight-search></app-flight-search>
        <div class="flex-row-container flex-row-container--right flight_research_row">
          <button
            i18n-title
            appButton="large-search"
            title="Start another search"
            (click)="reSearch()"
            i18n="@@flightSearch"
          >
            Search
          </button>
        </div>
      </app-search-toggle>
    </div>
    <app-risk-alerts
      [countryCode]="search?.arriveLocation?.countryCode"
      [autoExpand]="aiRiskFlag?.countryCode === search?.arriveLocation?.countryCode"
    ></app-risk-alerts>
    @if (searchParams?.railFromFlightSearchPerformed) {
      <div class="flex-column-container rail_and_carbon">
        @if (searchParams?.railFromFlightSearchPerformed) {
          <app-carbon-comparison
            [carbonPercentage]="carbonPercentage"
            (valueCalculated)="valueCalculated($event)"
          ></app-carbon-comparison>
        }
      </div>
    }
    @if (searchParams.eurostarFromFlightSearchPerformed) {
      <div class="flex-column-container rail_and_carbon">
        @if (searchParams.eurostarFromFlightSearchPerformed) {
          <app-carbon-comparison-eurostar
            (valueCalculated)="valueCalculated($event)"
          ></app-carbon-comparison-eurostar>
        }
      </div>
    }
    <div class="flex-row-container filters-and-extras results-width flex-column-mobile">
      @if ({ type: searchParams.choosenDisplayType | async }; as display) {
        @if (
          (searchParams.originalUserSearch.chosenSearchType !== FlightSearchType.oneWay &&
            search?.chosenSearchType !== FlightSearchType.multiCity) ||
          search?.chosenSearchType === FlightSearchType.multiCity
        ) {
          <div class="flex-column-container select-container">
            <label i18n="@@CurrentlyViewing2" class="extras-label" for="viewing-select"
              >Currently viewing:</label
            >
            @if (
              searchParams.originalUserSearch.chosenSearchType !== FlightSearchType.oneWay &&
              search?.chosenSearchType !== FlightSearchType.multiCity
            ) {
              <select
                appSelect
                [noIcon]="true"
                id="viewing-select"
                (ngModelChange)="searchParams.setFlightDisplayType($event)"
                [(ngModel)]="displayType"
              >
                <option
                  [ngValue]="FlightDisplayTypes.returns"
                  [selected]="display.type === FlightDisplayTypes.returns"
                >
                  <span i18n="@@flightDisplayReturns">Returns </span>
                  <span>{{ returnsCheapest }}</span>
                </option>
                <option
                  [ngValue]="FlightDisplayTypes.dualSingles"
                  [selected]="display.type === FlightDisplayTypes.dualSingles"
                >
                  <span i18n="@@flilghtDisplayDualsingles">Dual Singles </span>
                  <span>{{ dualCheapest }}</span>
                </option>
              </select>
            }
            @if (search?.chosenSearchType === FlightSearchType.multiCity) {
              <select
                appSelect
                [noIcon]="true"
                id="viewing-select"
                (ngModelChange)="searchParams.setFlightDisplayType($event); getFlightResults()"
                [(ngModel)]="displayType"
              >
                <option
                  [ngValue]="FlightDisplayTypes.byPrice"
                  [selected]="display.type === FlightDisplayTypes.byPrice"
                >
                  <span i18n="@@muliCityByPrice">By price</span> <span>{{ returnsCheapest }}</span>
                </option>
                <option
                  [ngValue]="FlightDisplayTypes.bySchedule"
                  [selected]="display.type === FlightDisplayTypes.bySchedule"
                >
                  <span i18n="@@muliCityBySchedule">By schedule</span>
                </option>
              </select>
            }
          </div>
        }
        <div class="flex-column-container select-container">
          <label i18n="@@SortingTitle" class="extras-label" for="sort-by-select">Sort by:</label>
          @if (
            display.type !== FlightDisplayTypes.dualSingles &&
            expandedFilters &&
            !searchParams.bySchedule
          ) {
            <app-flight-sort-by
              [filters]="searchParams.filters | async"
              [display]="FlightDisplayTypes.returns"
            ></app-flight-sort-by>
          }
          @if (searchParams.scheduledFilters | async; as filters) {
            @if (
              display.type !== FlightDisplayTypes.dualSingles &&
              expandedFilters &&
              searchParams.bySchedule
            ) {
              <app-flight-sort-by
                [filters]="filters[searchParams.selectedSegment]"
                [display]="FlightDisplayTypes.returns"
              ></app-flight-sort-by>
            }
          }
          @if (display.type === FlightDisplayTypes.dualSingles && expandedFilters) {
            <app-flight-sort-by
              [filters]="searchParams.duralSingleFilter | async"
              [display]="FlightDisplayTypes.dualSingles"
            ></app-flight-sort-by>
          }
        </div>
        <div class="flex-column-container">
          <span i18n="@@flightSearchTabsFilter" class="extras-label">Filter:</span>
          @if (
            display.type !== FlightDisplayTypes.dualSingles &&
            expandedFilters &&
            !searchParams.bySchedule
          ) {
            <app-filter-flights
              [filters]="searchParams.filters | async"
              [display]="FlightDisplayTypes.returns"
            ></app-filter-flights>
          }
          @if (searchParams.scheduledFilters | async; as filters) {
            <!-- Pass the filter at index i to app-filter-flights component -->
            @if (
              display.type !== FlightDisplayTypes.dualSingles &&
              expandedFilters &&
              searchParams.bySchedule
            ) {
              <app-filter-flights
                [filters]="filters[searchParams.selectedSegment]"
                [display]="FlightDisplayTypes.returns"
              ></app-filter-flights>
            }
          }
          @if (display.type === FlightDisplayTypes.dualSingles && expandedFilters) {
            <app-filter-flights
              [filters]="searchParams.duralSingleFilter | async"
              [display]="FlightDisplayTypes.dualSingles"
            ></app-filter-flights>
          }
        </div>
      }
      @if (
        searchParams.railFromFlightSearchPerformed &&
        railResultsCount &&
        !searchParams.isFlightHotelComboSearch
      ) {
        <button
          id="cheapest-rail-option"
          appButton="small"
          class="alternative-button"
          (click)="switchToRail()"
        >
          <i class="ico-rail" aria-hidden="true"></i>
          <span i18n="@@flightRailFrom">Rail from:</span>
          {{ cheapestRail | currency: 'GBP' }}
        </button>
      }
      @if (searchParams.isFlightHotelComboSearch) {
        <div class="alternative-button">
          <app-hotel-switch-button (switchToHotel)="switchToHotel()"> </app-hotel-switch-button>
        </div>
      }
      @if (
        searchParams.eurostarFromFlightSearchPerformed &&
        eurostarResultsCount &&
        !searchParams.isFlightHotelComboSearch
      ) {
        <section class="container">
          <ng-template #eurostarTooltip>
            @if (
              searchParams.eurostarFromFlightSearchPerformed &&
              carbonPercentage &&
              eurostarResultsCount
            ) {
              <span class="switchrail_text" i18n="@@eurostarSearchRailText"
                >Have you considered the Eurostar option? This could reduce your environmental
                impact by {{ carbonPercentage.toFixed() }}%</span
              >
            }
            <span i18n="@@EurostarFrom">Eurostar from:</span>
            {{ cheapestEurostar | currency: 'GBP' }}
          </ng-template>
          <button
            appButton="small"
            class="alternative-button"
            routerLink="/results/eurostar"
            [ngbTooltip]="eurostarTooltip"
            #eurostarTt="ngbTooltip"
            triggers="manual"
            (mouseenter)="eurostarTt.open()"
            (focus)="eurostarTt.open()"
            (blur)="eurostarTt.close()"
            (mouseleave)="eurostarTt.close()"
            id="eurostar-from"
          >
            <i class="custom_icon-eurostar"></i><span i18n="@@EurostarFrom">Eurostar from:</span>
            {{ cheapestEurostar | currency: 'GBP' }}
          </button>
        </section>
      }
      @if (
        (searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount ||
          isFastTrackEnable ||
          isParkingEnable) &&
        !searchParams.isFlightHotelComboSearch
      ) {
        <div class="flex-column-container extras">
          <span i18n="@@addAdditionalProducts" class="extras-label">Add additional products:</span>
          <div class="flex-row-container switchrail_container">
            <ng-template #hotelTooltip>
              <span i18n="@@flighttHotelsFrom">Hotels from:</span>
              {{
                searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount
                  | currency: searchService.searches[ServiceType.Hotel]?.cheapestPrice?.currencyCode
              }}
            </ng-template>
            <ng-template #fastTrackTooltip>
              <span i18n="@@AddFastTrack">Add fast track</span>
            </ng-template>
            <ng-template #parkingTooltip>
              <span i18n="@@AddParking">Add parking</span>
            </ng-template>
            @if (searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount) {
              <div class="flex-row-container">
                <section class="container" (mouseleave)="hotelTt.close()">
                  <button
                    (click)="switchToHotel()"
                    class="alternative-option-button"
                    id="flightresults-button-switchtoHotel"
                    [ngbTooltip]="hotelTooltip"
                    #hotelTt="ngbTooltip"
                    triggers="manual"
                    (mouseenter)="hotelTt.open()"
                    (focus)="hotelTt.open()"
                    (blur)="hotelTt.close()"
                    tabindex="0"
                  >
                    <i class="ico-bed" aria-hidden="true"></i>
                  </button>
                </section>
              </div>
            }
            @if (isFastTrackEnable || isParkingEnable) {
              <div class="flex-row-container rail_and_carbon">
                <div class="flex-row-container">
                  @if (isFastTrackEnable) {
                    <section class="container" (mouseleave)="fastTrackTt.close()">
                      <button
                        class="alternative-option-button margin-right-5"
                        id="add-fasttrack-option"
                        (click)="applyFastTrackSearch()"
                        [ngbTooltip]="fastTrackTooltip"
                        #fastTrackTt="ngbTooltip"
                        triggers="manual"
                        (mouseenter)="fastTrackTt.open()"
                        (focus)="fastTrackTt.open()"
                        (blur)="fastTrackTt.close()"
                        tabindex="0"
                      >
                        <i class="ico-fast-track ico-material" aria-hidden="true"></i>
                      </button>
                    </section>
                  }
                  @if (isParkingEnable) {
                    <section class="container" (mouseleave)="parkingTt.close()">
                      <button
                        class="alternative-option-button margin-right-5"
                        (click)="applyParkingSearch()"
                        id="add-parking-option"
                        [ngbTooltip]="parkingTooltip"
                        #parkingTt="ngbTooltip"
                        triggers="manual"
                        (mouseenter)="parkingTt.open()"
                        (focus)="parkingTt.open()"
                        (blur)="parkingTt.close()"
                        tabindex="0"
                      >
                        <i class="ico-parking ico-material" aria-hidden="true"></i>
                      </button>
                    </section>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="flex-row-container">
      <app-filter-pills
        [filters]="searchParams.currentFilters"
        [serviceType]="ServiceType.Flight"
      ></app-filter-pills>
    </div>
    @if ({ type: searchParams.choosenDisplayType | async }; as display) {
      <div class="flights_container results-width" id="flight-container-2">
        <div class="flex-row-container flex-column-mobile">
          @if (search?.departLocation && search?.arriveLocation) {
            <div class="flex-column-container width-100 flight-tickets-container">
              @if (
                display.type === FlightDisplayTypes.returns ||
                searchParams.chosenSearchType === FlightSearchType.oneway ||
                searchParams.chosenSearchType === FlightSearchType.multiCity
              ) {
                <div>
                  @if (data.flightResultsArray?.length) {
                    <div>
                      <app-flight-tickets [flights]="data.flightResultsArray"> </app-flight-tickets>
                    </div>
                  }
                  <div role="status">
                    @if (!data.flightResultsArray?.length && !data.loading) {
                      <ng-container *ngTemplateOutlet="noResults"></ng-container>
                    } @else if (!data.flightResultsArray?.length && data.loading) {
                      <ng-container *ngTemplateOutlet="searchLoading"></ng-container>
                    }
                  </div>
                </div>
              }
              <!-- Dual Singles -->
              @if (display.type === FlightDisplayTypes.dualSingles) {
                <div>
                  @if (data.dualFlightResultsArray?.length) {
                    <div>
                      @if (data.dualFlightResultsArray[0].results.length) {
                        <div>
                          <app-flight-tickets
                            tabindex="0"
                            [isDual]="true"
                            [flights]="data.dualFlightResultsArray[0].results"
                          >
                          </app-flight-tickets>
                        </div>
                      }
                      @if (data.dualFlightResultsArray[1].results.length) {
                        <div>
                          @if (!searchParams.fetchingRules) {
                            <div>
                              <app-flight-tickets
                                [isDualReturn]="true"
                                [flights]="data.dualFlightResultsArray[1].results"
                              >
                              </app-flight-tickets>
                            </div>
                          } @else {
                            <h2 class="applyingPolicies" i18n="@@applyingPolicies">
                              Applying policies... <app-loading-spinner size="sm" />
                            </h2>
                          }
                        </div>
                      }
                      <div role="status">
                        @if (
                          !data.loading &&
                          (!data.dualFlightResultsArray?.length ||
                            !data.dualFlightResultsArray[1].results.length ||
                            !data.dualFlightResultsArray[0].results.length)
                        ) {
                          <ng-container *ngTemplateOutlet="noResults"></ng-container>
                        }
                      </div>
                    </div>
                  } @else if (data.loading) {
                    <ng-container *ngTemplateOutlet="searchLoading"></ng-container>
                  }
                </div>
              }
            </div>
          }
          <ng-template #noResults>
            <app-no-results></app-no-results>
          </ng-template>
          <ng-template #searchLoading>
            <div class="flight-results-loading">
              <app-loading-spinner size="lg" position="inline"></app-loading-spinner>
              <span class="flight-results-loading__text" i18n="@@chatFlightSearchingFlights"
                >Searching for flights…</span
              >
            </div>
          </ng-template>
        </div>
      </div>
    }
  </div>
}
